// extracted by mini-css-extract-plugin
export default {"title":"TitleSubTitle_title__36jrV","subtitle":"TitleSubTitle_subtitle__N-j-y","container":"TitleSubTitle_container__BmKQD"};